//User
export const USER_START_LOADING = "USER_START_LOADING";
export const USER_FINISH_LOADING = "USER_FINISH_LOADING";
export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_SET_MESSAGE = "USER_SET_MESSAGE";